// modules
import { forEach } from 'lodash'

export const parsePatientName = (name) => {
  const parsedPatientName = {
    firstName: '',
    middleName: '',
    lastName: ''
  }

  if (typeof name !== 'string') {
    return parsedPatientName
  }

  const parts = name.split(' ').filter((part) => part)
  const partsAmount = parts.length

  switch (partsAmount) {
    case 0:
      return parsedPatientName
    case 1: {
      const [lastName] = parts
      parsedPatientName.lastName = lastName
      return parsedPatientName
    }
    case 2: {
      const [firstName, lastName] = parts
      parsedPatientName.firstName = firstName
      parsedPatientName.lastName = lastName
      return parsedPatientName
    }
    case 3: {
      const [firstName, middleName, lastName] = parts
      parsedPatientName.firstName = firstName
      parsedPatientName.middleName = middleName
      parsedPatientName.lastName = lastName
      return parsedPatientName
    }
    default: {
      const [firstName] = parts
      const lastName = parts[parts.length - 1]
      const middleName = parts.slice(1, -1).join(' ')
      parsedPatientName.firstName = firstName
      parsedPatientName.middleName = middleName
      parsedPatientName.lastName = lastName
      return parsedPatientName
    }
  }
}

export const dashToString = (number = '') => {
  let dashedNumber = null

  if (typeof number === 'string' && number.length) {
    dashedNumber = `${number.slice(0, 3)}-${number.slice(3, 6)}-${number.slice(
      6,
      10
    )}`
  }

  return dashedNumber
}

export const formatPhoneNumber = (value = '') => {
  if (value === null || value === undefined || value === '') {
    return value
  }

  const stringValue = typeof value === 'string' ? value : String(value)
  const digits = stringValue.replace(/\D/g, '')
  const normalized =
    digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits

  if (normalized.length !== 10) {
    return stringValue
  }

  const area = normalized.slice(0, 3)
  const prefix = normalized.slice(3, 6)
  const line = normalized.slice(6, 10)

  return `(${area}) ${prefix}-${line}`
}

export const getConfirmDeleteMessage = (deleteItem = '') =>
  `Delete ${deleteItem} list item?`

export const splitCamelCase = (field) =>
  field.replace(/^[a-z]|[A-Z]/g, (letter) => ` ${letter.toUpperCase()}`).trim()

export const replaceKeyWords = (string = '', replaceObj = {}) => {
  let updString = string

  forEach(replaceObj, (item, key) => {
    const regexp = new RegExp(key, 'g')

    updString = updString.replace(regexp, item)
  })

  return updString
}
